const createRestoreTimePlugin = ({ restoreTime }) => {
    const onStart = async () => {
        restoreTime.start();
    };
    const onRestoreCompleted = async ({ backupType }) => {
        void restoreTime.restoreCompleted({ backupType });
    };
    const onStop = async () => {
        restoreTime.stop();
    };
    return { onStart, onRestoreCompleted, onStop };
};
const restoreTimePluginDefinition = {
    id: 'restoreTimePlugin',
    type: 'plugin',
    factory: createRestoreTimePlugin,
    dependencies: ['restoreTime'],
    public: true,
};
export default restoreTimePluginDefinition;
